export default "__VITE_ASSET__DOzLlhiC__"